import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Questionnaire from '../components/Questionnaire';

import {
  addUserResponse,
  updateUserResponse,
  createResult,
  addUserExtraResponse
} from '../actions';

function mapStateToProps(state) {
  return {
    tests: state.tests,
    responses: state.responses,
    emotion: state.emotion
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addUserResponse: ({ id, start }) => {
      dispatch(addUserResponse(id, start));
    },
    collectResponse: (response, isTheLastTest) => {
      dispatch(updateUserResponse(response));

      if (!isTheLastTest) {
        dispatch(addUserResponse(response.testId + 1, response.end));
      }
    },
    createResult: (result) => {
      dispatch(createResult(result));
    },
    addUserExtraResponse: (response) => {
      dispatch(addUserExtraResponse(response));
    }
  };
}

const Test = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Questionnaire)
);

export default Test;



// WEBPACK FOOTER //
// ./app/containers/Test.js